import React from "react";
import { Route, Switch } from "react-router-dom";
import Home from './../components/pages/Home';
import Investment from './../components/pages/Investment'
import Trades from './../components/pages/Trades'
import AboutUs from './../components/pages/AboutUs'
import Shoab from './../components/pages/shoab'
import AcountNumber from './../components/pages/acountNumber';
import MangementUsers from './../components/pages/mangementUsers';
import ContactUs from './../components/pages/ContactUs';
import Energy from './../components/pages/energy';
import Kala from './../components/pages/kala';
import RegisterCar from './../components/pages/registerCar';
import ErrorPage from './ErrorPage404';
import Bourse from "./../components/pages/Bourse"
import Faq from "./../components/pages/faq";
import Education from "./../components/pages/Education";
import Linkes from "./../components/pages/linkes";
import DeceasedPeople from "./../components/pages/deceasedPeople/redirectNewProject.js";
import Deceased from "./../components/pages/deceased";
import ChartsKala from "./../components/pages/chartsKala";
import Oragh from "./../components/pages/oragh";
import Gift from './../components/pages/gift/gold/redirectNewProject.js';
import XmlToPdf from './../components/pages/xmlToPdf';
import Register from './../components/pages/register/register';
import LandingContentHtml from './../components/pages/LandingContentPage';



export default function RouteMain() {
  return (
    <div>
        <Switch>

          <Route  path="/xmlToPdf">
            <XmlToPdf />
          </Route>
          <Route  path="/gift">
            <Gift />
          </Route>
          <Route exact path="/links">
            <Linkes />
          </Route>
          <Route exact path="/faq">
            <Faq />
          </Route>
          <Route exact path="/education">
            <Education />
          </Route>
          <Route exact path="/khodro">
            <RegisterCar />
          </Route>
          <Route exact path="/Investment">
            <Investment />
          </Route>
          <Route exact path="/Trades">
            <Trades />
          </Route>
          <Route exact path="/AboutUs">
            <AboutUs />
          </Route>
          <Route exact path="/Shoab">
            <Shoab />
          </Route>
          <Route exact path="/AcountNumber">
            <AcountNumber />
          </Route>
          <Route exact path="/MangementUsers">
            <MangementUsers />
          </Route>
          <Route exact path="/ContactUs">
            <ContactUs />
          </Route>
          <Route exact path="/energy">
            <Energy />
          </Route>
          <Route exact path="/kala">
            <Kala />
          </Route>
          <Route exact path="/bourseKala">
            <Bourse />
          </Route>
          <Route exact path="/kalaReport">
            <ChartsKala />
          </Route>
          <Route exact path="/deceased-people">
            <DeceasedPeople />
          </Route>
          <Route exact path="/deceased">
            <Deceased />
          </Route>
          <Route exact path="/oragh">
            <Oragh />
          </Route>
          <Route  path="/register">
            <Register />
          </Route>
      
          <Route exact path="/">
            <Home />
          </Route>
          <Route  path="/Content/GetContentHtml/*" >
            <LandingContentHtml />
          </Route>
          <Route  path="*">
            <ErrorPage />
          </Route>
          <Route  path="/404">
            <ErrorPage />
          </Route>
        </Switch>
      {/* </Suspense> */}
    </div>
  );
}
